export default[
    {
        path: '/faqs',
        name: 'faqs-lists',
        beforeEnter() {
            window.open('https://bubbleinsupport.zendesk.com/hc/fr', '_blank')
        },        
        component: () => import('@/views/faqs/Lists.vue'),
    },
    {
        path: '/faqs/{id}',
        name: 'faqs-details',
        component: () => import('@/views/faqs/Details.vue'),
    },
]